import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
	name: 'filter'
})
export class FilterPipe implements PipeTransform {
	transform(items: any[], searchText: string, filterArg1: string, filterArg2: string): any[] {
		if (!items) {
			return [];
		}
		if (!searchText) {
			return items;
		}
		searchText = searchText.toLowerCase();
		return items.filter(it => {
			return (
				it[filterArg1].toLowerCase().includes(searchText) || it[filterArg2].toLowerCase().includes(searchText)
			);
		});
	}
}
